











































 import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
 import Util from '@/lib/util';
 import AbpBase from '@/lib/abpbase';
 import uploadContent from '@/store/entities/jm/uploadcontent';
 import SeverUrl from "@/lib/url";
  @Component
export default class UploadLetterOut extends AbpBase {
  @Prop({type:Boolean,default:false}) value:boolean;
  @Prop({type:String,default:false}) reftype:string;
  isLoading:boolean=false;
  modaltitle:string="上传";
  currForm=new uploadContent();
  uploadRules={
        fileimport:[{required: true,validator: this.checkFileCount, trigger: 'blur' }]
  }
  checkFileCount(rule, value, callback){
       if (this.currForm.fileImport.length===0) {
         callback(new Error('请先上传文件'));
       }else {
         callback();
       }
  }
  visibleChange(value) {
     if (!value) {
       (this.$refs["uploadRef"] as any).resetFields();
       this.$emit('input',false);
       this.currForm=new uploadContent();        
     }
     else{
        if(this.reftype=="outfile"){
            this.modaltitle="发函上传";
        }
        else if(this.reftype=="infile"){
            this.modaltitle="回函上传";
        }
     }
   }
  cancel() {
       (this.$refs["uploadRef"] as any).resetFields();
       this.$emit('input',false);
  }

  async save(){
   (this.$refs["uploadRef"] as any).validate(async (valid) => {
       if(valid){
       if(this.currForm.fileImport.length>0){
           this.isLoading=true;
           var currid=this.$store.state.jobdo.currjob;
           var formData = new FormData(); 
           this.currForm.fileImport.forEach(file => { 
               formData.append('letterFile', file.raw, file.raw.name); 
           })
           formData.append('currId',currid);
           formData.append('itemType',this.reftype);
           let response=await this.$store.dispatch({
               type:'hzletter/uploadfile',
               data:formData
           });
           if(response.success){
               this.$message({
                 message: '附件已上传',
                 type: 'success'
               });
               this.isLoading=false;
               (this.$refs["uploadRef"] as any).resetFields();
                this.$emit('input',false);
               this.$emit('upload-success');
           }
           else{
               this.$alert(response.message,'提示',{type:'info'});
               this.isLoading=false;
           }
       }
       else{
        this.$alert('请选择文件','提示',{type:'info'});
       } 
       }
       else{return false;}
   });
  }
  fileonChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$alert('上传文件不能超过99M','提示',{type:'info'});
        fileList.pop();
      }
      this.currForm.fileImport = fileList;
      //this.checkFileCount;
      (this.$refs.uploadRef as any).validateField('fileimport');
  }
  fileonRemove (file, fileList) {
    this.currForm.fileImport = fileList;
  }
  handleFileRemove(file) {
    let uploadFiles = (this.$refs["fileUpload"] as any).uploadFiles;
    for (var i = 0; i < uploadFiles.length; i++) {
      if (uploadFiles[i]['uid'] == file.uid) {
        uploadFiles.splice(i, 1)
      }
    }
    this.currForm.fileImport=uploadFiles;
  }
  async created(){
  }
}
